@use '@/styles/tokens' as *;

// Internal Users status chip (Figma 577-30813, 765:281917):
// green Active / red Inactive / amber Activation Pending.
.chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 18px;
  padding: 3px 8px;
  border-radius: 24px;
  font-size: 11px;
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;
}

.active {
  background: $color-success-100;
  color: $color-success-900;
}

.inactive {
  background: $color-error-100;
  color: $color-error-900;
}

// Activation Pending (Figma 765:281917): the same amber the Customer listing uses for this status.
.pending_activation {
  background: $color-stage-review-bg;
  color: $color-stage-review-text;
}
